"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FinStatementCsvLineItemArraySchema = exports.DatabaseSchema = exports.DataSourceSchema = exports.StatementBasisSchema = exports.SectionSchema = exports.IncomeStatementSectionSchema = exports.BalanceSheetSectionSchema = exports.StatementSchema = exports.ReportFrequencySchema = void 0;
const Bank_1 = require("./Bank");
const Utils_1 = require("./Utils");
const zod_1 = require("zod");
/**
 * BASE TYPES
 */
exports.ReportFrequencySchema = zod_1.z.enum(['month', 'quarter', 'year']);
exports.StatementSchema = zod_1.z.enum(['balanceSheet', 'incomeStatement']);
exports.BalanceSheetSectionSchema = zod_1.z.enum([
    'assets',
    'liabilities',
    'equity',
]);
exports.IncomeStatementSectionSchema = zod_1.z.enum(['income', 'expenses']);
exports.SectionSchema = zod_1.z.union([
    exports.BalanceSheetSectionSchema,
    exports.IncomeStatementSectionSchema,
]);
exports.StatementBasisSchema = zod_1.z.enum(['plan', 'actual']);
exports.DataSourceSchema = zod_1.z.enum(['dataPipeline', 'railz']);
/**
 * TABLE SCHEMA
 */
exports.DatabaseSchema = zod_1.z.enum(['pg', 's3']);
const FinStatementRecordSchema = zod_1.z.object({
    id: zod_1.z.string(),
    organizationId: zod_1.z.string(),
    endOfPeriodDate: Utils_1.ZodFullDateStrStruct,
    version: zod_1.z.int(),
    statement: exports.StatementSchema,
    reportFrequency: exports.ReportFrequencySchema,
    currency: Bank_1.CurrencyCodeSchema,
    basis: exports.StatementBasisSchema,
    dataSource: exports.DataSourceSchema,
    rawSourceDb: exports.DatabaseSchema.nullable(),
    rawSourceNamespace: zod_1.z.string().nullable(),
    rawSourceIdentifier: zod_1.z.string().nullable(),
    markupS3Bucket: zod_1.z.string().nullable(),
    markupS3Key: zod_1.z.string().nullable(),
});
const FinStatementLineItemSchema = zod_1.z.object({
    section: exports.SectionSchema,
    ledgerName: zod_1.z.string(),
    value: zod_1.z.number(),
    groups: zod_1.z.array(zod_1.z.string()),
});
const FinStatementCsvLineItemSchema = FinStatementLineItemSchema.omit({
    groups: true,
}).extend({ groups: zod_1.z.string().nullable().optional().default('') }); // groups is a pipe | delimited string
exports.FinStatementCsvLineItemArraySchema = zod_1.z.array(FinStatementCsvLineItemSchema);
const FinStatementLineItemRecordSchema = FinStatementLineItemSchema.extend({
    id: zod_1.z.string(),
    finStatementId: zod_1.z.string(),
});
const FinStatementSchema = FinStatementRecordSchema.extend({
    lineItems: zod_1.z.array(FinStatementLineItemRecordSchema),
});
//# sourceMappingURL=FinStatementsV2.js.map